import { SpfAddressFieldModifications, customValidate } from "./hooks/woocommerce";

const { CHECKOUT_STORE_KEY } = window.wc.wcBlocksData;
const { registerPlugin } = window.wp.plugins;

// Set the internal flag to create an account during checkout
window.wp.data.dispatch(CHECKOUT_STORE_KEY).__internalSetShouldCreateAccount(true);

const SpfRenderCheckoutModifications = ({ cart }) => {
  SpfAddressFieldModifications();
  customValidate();

  return null;
};

/**
 * Registers the "spf-checkout-plugin" plugin to render the checkout form.
 * The plugin renders the checkout form by modifying the WooCommerce settings.
 * The plugin is scoped to the "woocommerce-checkout" area.
 *
 * @function registerPlugin
 * @global registerPlugin
 */
registerPlugin("spf-checkout-plugin", {
  render: SpfRenderCheckoutModifications,
  scope: "woocommerce-checkout",
});
